import Box from "@/components/Box";
import ExerciseIcon from "@/images/ExerciseIcon";
import HeartIcon from "@/images/HeartIcon";
import OrangeIcon from "@/images/OrangeIcon";
import ChevronComponent from "@/tpo/Chevron";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";

function SuggestionCard({ accentColor, title, description, iconVariant }) {
  const iconMap = {
    orange: OrangeIcon,
    blue: ExerciseIcon,
    purple: HeartIcon
  };

  const IconComponent = iconMap[iconVariant];

  return (
    <Group
      bg="white"
      borderRadius={12}
      overflow="hidden"
      minHeight={88}
      alignItems="stretch"
      justifyContent="space-between"
      gap={0}
    >
      <Box
        width={80}
        bg={accentColor}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        {IconComponent ? (
          <IconComponent size={30} withCircle={false} color="#1A1A1A" />
        ) : (
          <Box width={30} height={30} borderRadius="50%" border="2px solid #1A1A1A" />
        )}
      </Box>
      <Group
        justifyContent="space-between"
        alignItems="center"
        flexGrow={1}
        px={[14, 16, 20]}
        py={[14, 14, 16]}
        gap={12}
      >
        <Stack gap={4} maxWidth={["100%", "100%", "86%"]}>
          <Box fontFamily="gilroyBold" fontSize={[14, 14, 16]} lineHeight="1.25">
            {title}
          </Box>
          <Box fontFamily="gilroyMedium" fontSize={[12, 12, 14]} lineHeight="22px">
            {description}
          </Box>
        </Stack>
        <Box
          width={48}
          height={48}
          borderRadius={24}
          bg="haze"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          <ChevronComponent direction="right" fill="dark" width={10} />
        </Box>
      </Group>
    </Group>
  );
}

export default function SuggestionsTabContent() {
  const suggestionCards = [
    {
      id: "detox-1",
      accentColor: "#FF905F",
      iconVariant: "orange",
      title: "Support Phase I detoxification",
      description: "Lifestyle and nutrient interventions to improve initial biotransformation."
    },
    {
      id: "detox-2",
      accentColor: "#17C6E9",
      iconVariant: "blue",
      title: "Strengthen antioxidant protection",
      description: "Strategies to reduce intermediate oxidative burden and improve resilience."
    },
    {
      id: "detox-3",
      accentColor: "#FF905F",
      iconVariant: "orange",
      title: "Optimise methylation capacity",
      description: "Targeted actions to support methyl donor pathways and cofactor balance."
    },
    {
      id: "detox-4",
      accentColor: "#CCBAFF",
      iconVariant: "purple",
      title: "Balance hormone clearance",
      description: "Approaches for improved conjugation and elimination of hormone metabolites."
    },
    {
      id: "detox-5",
      accentColor: "#17C6E9",
      iconVariant: "blue",
      title: "Improve gut-liver coordination",
      description: "Protocol suggestions to support enterohepatic detoxification flow."
    },
    {
      id: "detox-6",
      accentColor: "#FF905F",
      iconVariant: "orange",
      title: "Reduce toxic exposure load",
      description: "Practical environmental changes to lower cumulative detox demand."
    }
  ];

  return (
    <Stack gap={20}>
      <Box fontFamily="gilroyBold" fontSize={[20, 22, 24]} lineHeight="1.25">
        Suggested actions
      </Box>
      <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="26px">
        Recommended actions are grouped by detoxification and methylation priorities to help guide
        practical next steps.
      </Box>
      <Box display="grid" gridTemplateColumns={["1fr", "1fr", "1fr 1fr"]} gap={20}>
        {suggestionCards.map(card => (
          <SuggestionCard
            key={card.id}
            accentColor={card.accentColor}
            iconVariant={card.iconVariant}
            title={card.title}
            description={card.description}
          />
        ))}
      </Box>
    </Stack>
  );
}
